import log from 'loglevel';
import { TriggerManager } from '../trigger-manager/trigger-manager';

interface UpdateEventData {
  userId?: string;
  traits?: {
    [key: string]: string
  },
  type: 'update'
}

/**
 * Will trigger a call to the tracking API to add or update the user traits for the user with the current globalUserId.
 * @param an object of traits to be addded or updated.
 */
export default function(argument: {[key: string]: string}): Promise<unknown> | void {
  if (!argument) {
    log.error('update trigger: Must provide an argument.');
    return;
  }
  if (!Object.keys(argument).length) {
    log.error(`identify trigger: Argument of type ${typeof argument} not allowed or traits are not defined.`);
    return;
  }
  return TriggerManager.eventRequest<UpdateEventData>('identify', {type: 'update', traits: argument});
}